// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__hjxuc","col":"CardReaderDesc_col__226x1","label":"CardReaderDesc_label__3a9dr"};